import { debounce } from 'lodash';
import { Util } from './_util.js';
import Cookies from 'js-cookie';
import 'regenerator-runtime/runtime';
import domReady from './modules/domReady.js';

const Klaviyo = {
  pageLoad: function() {
    window.addEventListener('load', (event) => {
      setTimeout(() => {
        //Viewed Product tracking snippet
        if (window.hasOwnProperty('_learnq')) {
          async function callC7() {
            let productSlugTerm = await Klaviyo.productSlug();
            Klaviyo.trackingSnippets(productSlugTerm);
          }

          callC7();
          //Klaviyo.watchAddToCart();
        }
      }, 2000);
    });
  },
  trackingSnippets: function(productSlug) {
    let url = new URL(window.location.href);
    if (!url.pathname.includes('product')) return false;

    fetch(`https://api.commerce7.com/v1/product/slug/${productSlug}/for-web`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: 'rombauer-vineyards',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let _learnq = window._learnq || [];

        let collectionArray = [];
        data.collections.forEach((e) => {
          collectionArray.push(e.title);
        });

        let viewedProductItemPackage = {
          'ProductName': data.title,
          'ProductID': data.id,
          'SKU': data.variants[0]?.sku,
          'Categories': collectionArray,
          'ImageURL': data.images[1]?.src,
          'URL': window.location.href,
          'Price': data.variants[0]?.price / 100,
        };
        _learnq.push(['track', 'Viewed Product', viewedProductItemPackage]);

        let trackViewedItemPackage = {
          'Title': data.title,
          'ItemId': data.id,
          'Categories': collectionArray,
          'ImageUrl': data.images[1]?.src,
          'Url': window.location.href,
          'Metadata': {
            'Price': data.variants[0]?.price / 100,
          },
        };

        _learnq.push(['trackViewedItem', trackViewedItemPackage]);

        // console.log('success:', data);
      });
  },
  watchAddToCart: async () => {
    let origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      console.log('request started!');
      this.addEventListener('load', function() {
        console.log('request completed!');
        console.log(this.readyState); //will always be 4 (ajax is completed successfully)
        Klaviyo.addToCartLogic(JSON.parse(this.responseText));
      });
      origOpen.apply(this, arguments);
    };


    /*
    // The above code doesn't work. The code below code works for detecting the entire cart. Disabled for now
    // since Klaviyo recommends to send individual items for each Add to Cart event.
    const xmlHttpRequestPrototype = Object.getPrototypeOf(new window.XMLHttpRequest());
    const originalOpen = xmlHttpRequestPrototype.open;
    const originalSend = xmlHttpRequestPrototype.send;
  
    xmlHttpRequestPrototype.open = function() {
      this._url = arguments[1];
      this._method = arguments[0];
      return originalOpen.apply(this, arguments);
    };
  
    xmlHttpRequestPrototype.send = function() {
      const HOST_NAME = 'api.commerce7.com';
      const ATC_PATH_NAME = /^\/v2\/cart\/(?:[A-Za-z0-9\-]+)\/item\/?$/i;
      const url = new URL(this._url);
  
      if (
        url.hostname === HOST_NAME &&
        ATC_PATH_NAME.test(url.pathname) &&
        arguments[0] &&
        this._method === 'POST'
      ) {
        this.addEventListener('load', function() {
          if (this.readyState === 4 && this.status === 200) {
            Klaviyo.addToCartLogic(JSON.parse(this.responseText));
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
    */
  },
  addToCartLogic: async (data) => {
    console.log('outside', data);

    if (data.status == 'Pending') {
      //console.log('added to cart', data);

      let _learnq = window._learnq || [];

      let itemArray = [];
      data.items.forEach((e) => {
        let itemObj = {
          'ProductID': e.productId,
          'SKU': e.sku,
          'ProductName': e.productTitle,
          'Quantity': e.quantity,
          'ItemPrice': e.price,
          'RowTotal': 9.99,
          'ProductURL': `https://rombauer.com/product/${e.productSlug}`,
          'ImageURL': e.image,
        };
        itemArray.push(itemObj);
      });

      console.log('itemArray', itemArray);

      let addedtoCartPackage = {
        'Items': itemArray,
      };

      _learnq.push(['track', 'Added to Cart', addedtoCartPackage]);
    }
  },
  productSlug: async () => {
    let url = new URL(window.location.href);
    let urlArray = url.pathname.split('/');
    let productSlug = urlArray[2];

    return new Promise((resolve) => {
      resolve(productSlug);
    });
  },
  checkCustomer: async () => {
    let customerToken = Cookies.get('customerToken');

    if (typeof customerToken == 'undefined') return;
    // console.log('customerToken', Cookies.get('customerToken'));

    fetch(`https://api.commerce7.com/v1/customer/self`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: 'rombauer-vineyards',
        authorization: customerToken,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(response.status);
        } else {
          return response.json();
        }
      })
      .then((data) => {
        // console.log('I am logged in', data);
        let _learnq = _learnq || [];
        _learnq.push(['identify', { '$email': data.emails[0].email, '$first_name': data.firstName, '$last_name': data.lastName }]);
      })
      .catch(function(error) {
        console.log('fetch member error');
      });
  },
  // Identify email from Checkout and Club Signup Pages
  watchC7FormEmail: () => {
    domReady('#c7-checkout form.c7-form input[name="email"]', (input) => {
      const form = input.closest('form');

      form.addEventListener('submit', e => {
        const email = e.target.querySelector('input[name="email"]')?.value?.trim();

        if (!email) {
          return;
        }

        const _learnq = window._learnq || [];
        _learnq.push(['identify', { '$email': email }]);
      })
    });
  },
  // Track `Added to Cart` events from any Add to Cart button
  watchProductAddToCart: () => {
    domReady('form.c7-product__add-to-cart', (form) => {
      form.addEventListener('submit', () => {
        const reactPropsValue = findReactProps(form);
        if (!reactPropsValue?.children?.length) {
          return;
        }

        reactPropsValue.children.some((child) => {
          if (!Array.isArray(child)) {
            return false;
          }

          child.some((child2) => {
            const product = child2?.props?.product;

            if (!product) {
              return false;
            }

            const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1;
          
            Klaviyo.sendProductAddToCartEvent(product, quantity);
            return true
          });
          
          return true;
        })
      });
    });


    function findReactProps(element) {
      for (const key in element) {
        if (key.startsWith('__reactProps')) {
          return element[key];
        }
      }
      return null;
    }
  },
  sendProductAddToCartEvent: (product, quantity) => {
    if (!product.id || !product.variants?.[0]) {
      return;
    }
    const variant = product.variants[0];
    const price = ((variant.addToCartPrice || variant.price) / 100).toFixed(2);

    const payload = {
      'ProductID': product.id,
      'SKU': variant.sku,
      'ProductName': product.title,
      'Quantity': quantity,
      'ItemPrice': price,
      'ProductURL': `https://rombauer.com/product/${product.slug}`,
      'ImageURL': product.image || product.images?.[0]?.src,
      'VariantID': variant.id,
    };
    
    const _learnq = window._learnq || [];
    _learnq.push(['track', 'Added to Cart', payload]);
  },
  init: function() {
    this.pageLoad();
    this.checkCustomer();
    this.watchProductAddToCart();
    this.watchC7FormEmail();
  },
};

export default Klaviyo;
